import axios from 'axios';
import { baseURL } from '../baseURL';
import Cookies from 'js-cookie';

export const get1688Deliveries = (currentPage, trackCode, country) => {
    return axios.get(`${baseURL}amantrans/late-orders?page=${currentPage}`, {
        params: {
            trackCode,
            country,
        },
        headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
        },
    });
};

export const calledClient = (trackCode) => {
    return axios.post(
        `${baseURL}amantrans/late-orders-mark`,
        { trackCode },
        {
            headers: {
                Authorization: `Bearer ${Cookies.get('token')}`,
            },
            params: {
                trackCode,
            },
        },
    );
};
